import React, { FC } from 'react';
import { FaUser } from 'react-icons/fa6';
import { IconProps } from './common/iconProps';

export const PersonIcon: FC<IconProps> = ({ className }) => <FaUser className={className} />;
